import { cva } from "class-variance-authority";

import { cn } from "@/shared/helpers/cn.helper";

import Typography from "../typography/typography";

const tableCellVariants = cva("", {
  variants: {
    variant: {
      default: [
        "bg-white",
        'data-[special="true"]:bg-special',
        Typography.classes.Body.default,
        Typography.classes.Body.classnames.mRegular,
      ],
      highlighted: [
        "bg-background-table-highlighted",
        'data-[special="true"]:bg-special-active',
        Typography.classes.Body.default,
        Typography.classes.Body.classnames.mRegular,
      ],
      summary: [
        "bg-background-table-summary",
        "data-[special='true']:bg-special-active",
        Typography.classes.Title.default,
        Typography.textTransformModifiers.capitalize,
        Typography.classes.Title.classnames.subTitle,
      ],
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export interface TableCellProps extends Omit<React.ComponentProps<"td">, "className"> {
  variant?: "default" | "highlighted" | "summary";
  "data-special"?: boolean;
  isHighlighted?: boolean;
  className?: string |  string[]; 
}

export const TableCell: React.FC<TableCellProps> = ({
  className,
  variant,
  ...props
}) => {
  return (
    <td
      className={cn(
        "h-12",
        "whitespace-nowrap p-2 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        tableCellVariants({ variant }),
        "border-b border-r border-border-2 last:border-r-0",
        className,
      )}
      data-slot="table-cell"
      {...props}
    />
  );
};
